import styled from "styled-components";

import StyledCard from "../components/card/styles/StyledCard.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import StyledResolvedCard from "../components/resolved-card/styles/StyledResolvedCard-APP_CLIENT.styled";

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  padding-top: 24px;

  ${StyledCard}, ${StyledResolvedCard} {
    max-width: 375px;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    grid-template-columns: 1fr;
  }
`;

export default CardsContainer;
